<template>
    <div>
        <h2 class="mb-0">
            <span v-if="orderCancelled" class="text-danger">
                [{{order.status_label}}]
            </span>
            {{ customerTypeLabel }} :

            <OrderIcon :type="order.final_customer_type" :online="order.online === 1"></OrderIcon>
            {{ finalCustomer.name }}
            <template v-if="!order.is_recurrent && order.counters.nb_missing > 0">
                <MissingProductsIcon></MissingProductsIcon>
            </template>
        </h2>

        <div v-if="finalCustomer.type === 'store'">
            <a :href="'/espace-employes/clients/' + finalCustomer.id" target="_blank">
                <i class="fas fa-external-link"></i>
                Voir la fiche du magasin
            </a>
        </div>
        <div v-else-if="finalCustomer.type === 'short_channel' || finalCustomer.type === 'customer_group'">
            <a :href="'/espace-employes/clients/' + finalCustomer.id" target="_blank">
                <i class="fas fa-external-link"></i>
                Voir la fiche du client
            </a>
        </div>
        <template v-if="order && order.id">
            <div v-if="!order.is_recurrent" class="mt-3">
                <OrderIcon :type="order.final_customer_type" :online="order.online === 1"></OrderIcon>
                <OrderTypeName :type="order.final_customer_type" :online="order.online === 1"></OrderTypeName>
                n°<strong><u>{{ order.reference }}</u></strong><br />
                <small v-if="order.external_website">
                    Commande passée sur
                    <a v-if="order.external_website"
                        target="_blank"
                        :href="`https://${order.external_website.domain}/wp-admin/edit.php?post_type=shop_order&s=${order.origin_id}`">
                        {{ order.external_website.domain }} <i class="fas fa-external-link"></i>
                    </a>
                </small>
                <small v-if="order.final_customer_type === 'short_channel' && order.customer">
                    Commande importée depuis <span class="text-warning">{{ order.customer.meta.channel_type }}</span>
                </small>
            </div>

            <div v-if="order.paid_at">
                <i class="fas fa-fw fa-euro-sign" style="color:yellowgreen"></i>
                Commande <u>payée d'avance</u>
                <i class="fas fa-fw fa-check" style="color:yellowgreen"></i>
                le {{ global.moment(order.paid_at).format('dddd D MMMM Y [à] H[h]mm') }}
            </div>
            <template v-else-if="order.final_customer_type === 'store'">
                <div :class="{'mt-3': order.is_recurrent}">
                    <i class="fas fa-fw fa-store-alt" style="color:orange"></i>
                    Commande <u>magasin</u>
                    <i class="fad fa-fw fa-store"></i>, facturée après livraison
                </div>

                <div v-if="order.is_recurrent">
                    <i class="fas fa-fw fa-repeat" style="color:gray"></i>
                    Modèle de commande hebdomadaire automatique
                </div>

                <div v-if="order.fk_recurrent_order">
                    <i class="fas fa-fw fa-repeat" style="color:gray"></i>
                    Commande hebdomadaire automatique
                </div>
            </template>
            <div v-else-if="order.final_customer_type === 'pickup_point'">
            </div>
            <div v-else-if="order.final_customer_type === 'customer_group'">
            </div>
            <div v-else>
                <i class="fas fa-fw fa-hand-holding-usd" style="color:Tomato"></i>
                Commande <u>à régler lors du retrait</u>
                <UnpaidOrderIcon></UnpaidOrderIcon>
            </div>

            <div v-if="order.missing_products && order.missing_products.length && order.final_customer_type !== 'pickup_point'" class="mt-3">
                <MissingProductsIcon></MissingProductsIcon>
                Un ou plusieurs produits sont manquants
            </div>

            <div class="mt-3">
                Commande passée par :
                <span>
                    {{ order.creator.name }}
                    <i>({{ order.creator.type_label }})</i>
                </span>
                <small class="text-muted font-italic" v-if="infoModal">
                    le {{ global.moment(order.created_at).format('D/MM/Y à H:mm') }}
                </small>
            </div>

            <div v-if="!infoModal">
                <div>
                    <template v-if="order.is_recurrent">
                        Jour de livraison / Retrait :
                        tous les {{ global.moment(order.delivery_date).format('dddd') }}
                        <span v-if="global.moment(order.delivery_date).isAfter()" class="text-danger">
                            à partir du {{ global.moment(order.delivery_date).format('D MMM Y') }}
                        </span>
                    </template>
                    <template v-else>
                        Livraison / Retrait :
                        {{ global.moment(order.delivery_date).format('dddd D MMMM Y') }}
                    </template>
                    <span v-if="order.customer && order.customer.name">
                        -
                        {{ order.customer.name }}
                    </span>
                </div>
                <div v-if="order.final_customer_type === 'customer_group'">
                    Date de fermeture des commandes :
                    {{ global.moment(order.closing_date).format('dddd D MMMM Y') }}
                </div>
            </div>
            <div v-else>
                <div v-if="order.customer">
                    Lieu de retrait :
                    {{ order.customer.name }}
                </div>

                <template v-if="order.is_recurrent">
                    <div>
                        Jour de livraison / retrait :
                        tous les {{ global.moment(order.delivery_date).format('dddd') }}
                        <span v-if="global.moment(order.delivery_date).isAfter()" class="text-danger">
                            à partir du {{ global.moment(order.delivery_date).format('D MMM Y') }}
                        </span>
                    </div>
                </template>
                <template v-else>
                    <div>
                        Date de livraison / retrait :
                        {{ global.moment(order.delivery_date).format('dddd D MMMM Y') }}
                    </div>
                    <div>
                        Date de fin de préparation :
                        {{ global.moment(order.end_preparation_date).format('dddd D MMMM Y') }}
                    </div>
                    <template v-if="order.final_customer_type === 'customer_group'">
                        <div>
                            Date de fermeture des commandes :
                            {{ global.moment(order.closing_date).format('dddd D MMMM Y') }}
                        </div>
                        <div>
                            Image de la commande :
                            <img v-if="order.logo_url" class="align-top" :src="order.logo_url" alt="Image de la commande">
                            <span v-else>(aucune image)</span>
                        </div>
                    </template>
                </template>

                <div class="mt-3" v-if="order.customer.name">
                    {{ finalCustomer.name }}
                    <a  v-if="finalCustomer.type === 'store'"
                        :href="'/espace-employes/clients/' + finalCustomer.id" target="_blank">
                        <i class="fas fa-external-link"></i>
                        Voir la fiche
                    </a>
                </div>
                <div v-if="finalCustomer.meta.phone">
                    <i class="fad fa-phone-square"></i>
                    Téléphone :
                    {{ finalCustomer.meta.phone }}
                </div>
                <div v-if="finalCustomer.meta.email">
                    <i class="fad fa-envelope-open-text"></i>
                    Email :
                    {{ finalCustomer.meta.email }}
                </div>

                <div v-if="order.customer.meta.delivery_address">
                    <i class="fad fa-dolly"></i>
                    {{ order.customer.meta.delivery_address }}
                </div>

                <div v-if="order.customer.meta.contact_tel">
                    <i class="fad fa-fw fa-phone-square"></i>
                    Téléphone :
                    {{ order.customer.meta.contact_tel }}
                </div>
                <div v-if="order.customer.meta.contact_mobile">
                    <i class="fad fa-fw fa-mobile-alt"></i>
                    Mobile :
                    {{ order.customer.meta.contact_mobile }}
                </div>
                <div v-if="order.customer.meta.contact_email">
                    <i class="fad fa-fw fa-envelope-open-text"></i>
                    Email :
                    {{ order.customer.meta.contact_email }}
                </div>
                <div v-if="order.customer.meta.contact_name">
                    <i class="fad fa-fw fa-user"></i>
                    Contact : {{ order.customer.meta.contact_name }}
                </div>

                <div v-if="order.customer.contacts && order.customer.contacts.length > 0" class="mt-2">
                    {{ order.customer.meta.contact_name ? "Tous les contacts :" : "Contacts :" }}
                    <div class="ml-4" v-for="contact in order.customer.contacts">
                        {{ contact.name }}
                        <div class="ml-4">
                            <div v-if="contact.tel">
                                <i class="fad fa-fw fa-phone-square"></i>
                                Téléphone :
                                {{ contact.tel }}
                            </div>
                            <div v-if="contact.mobile">
                                <i class="fad fa-fw fa-mobile-alt"></i>
                                Mobile :
                                {{ contact.mobile }}
                            </div>
                            <div v-if="contact.email">
                                <i class="fad fa-fw fa-envelope-open-text"></i>
                                Email :
                                {{ contact.email }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import MissingProductsIcon from "./MissingProductsIcon"
    import OrderIcon from "./OrderIcon"
    import UnpaidOrderIcon from "./UnpaidOrderIcon"
    import OrderTypeName from "./OrderTypeName"

    import {orderCancelled} from "../../orders-utils";

    export default {
        name: 'PreparationCustomerOrderCustomerInformation',

        components: {
            OrderIcon,
            UnpaidOrderIcon,
            OrderTypeName,
            MissingProductsIcon
        },

        props: {
            order: {
                type: Object,
                required: true,
            },
            infoModal: {
                type: Boolean,
            },
        },

        computed: {
            orderCancelled,

            customerTypeLabel() {
                switch (this.order.final_customer_type) {
                    case 'store':
                        return 'Magasin';
                    case 'short_channel':
                        return 'Circuit court';
                    case 'customer_group':
                        return 'Groupement de clients';
                    case 'pickup_point':
                        return 'Lieu de retrait';
                    case 'pickup_point_subcustomer':
                        return 'Client';
                    default:
                        return 'Client';
                }
            },

            finalCustomer() {
                if (this.order.subcustomer) {
                    return this.order.subcustomer;
                }
                return this.order.customer;
            },
        },
    }
</script>
